import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const getCountryCodeByPhoneNumber = (rawNumber: string) => {
  try {
    const phoneNumber = phoneUtil.parseAndKeepRawInput(rawNumber);
    return phoneUtil.getRegionCodeForNumber(phoneNumber) || '';
  } catch {
    return '';
  }
};

export const formatPhoneNumberForStore = (phoneNumber: string) => {
  return phoneNumber.replace(/[^\d+]/g, '');
};

export const formatPhoneNumberInternational = (rawNumber: string) => {
  try {
    const phoneNumber = phoneUtil.parse(rawNumber);
    const countryCode = '+' + phoneNumber.getCountryCode();
    const formattedNumber = phoneUtil.format(phoneNumber, PhoneNumberFormat.INTERNATIONAL);
    const numberWithoutCountryCode = formattedNumber.replace(countryCode, '').trim();
    return `${countryCode} ${numberWithoutCountryCode}`;
  } catch {
    return rawNumber;
  }
};

export const formatPhoneNumberForView = (rawNumber: string): string => {
  if (!rawNumber) return '';
  try {
    const regionCode = getCountryCodeByPhoneNumber(rawNumber);
    const number = phoneUtil.parseAndKeepRawInput(rawNumber, regionCode);
    if (!number) return rawNumber;

    if (phoneUtil.getRegionCodeForNumber(number) === 'US') {
      return phoneUtil.format(number, PhoneNumberFormat.NATIONAL);
    }
    return phoneUtil.format(number, PhoneNumberFormat.INTERNATIONAL);
  } catch {
    return rawNumber;
  }
};

export const getPhoneWithoutPrefix = (phone: string) => {
  try {
    const phoneInstance = phoneUtil.parse(phone);
    return phoneUtil.format(phoneInstance, PhoneNumberFormat.NATIONAL);
  } catch {
    return phone;
  }
};
